import React from 'react';
import { Box, Typography, Paper, IconButton, List, ListItem } from '@mui/material';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';

interface WorkDayEntry {
    date: string;
    dayLabel?: string;
    hours: string;
    status: 'success' | 'failure';
}

interface WorkHoursHistoryProps {
    title?: string;
    entries: WorkDayEntry[];
    onCalendarClick?: () => void;
    onReportClick?: () => void;
    onEditEntry?: (entry: WorkDayEntry) => void;
}

const WorkHoursHistory: React.FC<WorkHoursHistoryProps> = ({
    title = 'Historial de horas trabajadas conductor',
    entries = [],
    onCalendarClick = () => { },
    onReportClick = () => { },
    onEditEntry = () => { }
}) => {
    return (
        <Paper
            elevation={0}
            sx={{
                borderRadius: 2,
                border: '1px solid #e0e0e0',
                overflow: 'hidden',
                width: '100%'
            }}
        >
            <Box
                sx={{
                    p: 3,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }}
            >
                <Typography variant="h6" component="h2" fontWeight="500">
                    {title}
                </Typography>

                <Box>
                    <IconButton onClick={onReportClick} color="default" size="small" sx={{ mr: 1 }}>
                        <DescriptionOutlinedIcon />
                    </IconButton>
                    <IconButton onClick={onCalendarClick} color="default" size="small">
                        <CalendarTodayOutlinedIcon />
                    </IconButton>
                </Box>
            </Box>

            <List sx={{ width: '100%', p: 0 }}>
                {entries.map((entry, index) => (
                    <ListItem
                        key={index}
                        sx={{
                            py: 2.5,
                            px: 3,
                            display: 'block',
                            bgcolor: 'background.paper',
                            borderTop: index > 0 ? '1px solid #f0f0f0' : 'none'
                        }}
                    >
                        <Box sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            mb: 0.5
                        }}>
                            <Typography variant="subtitle1" fontWeight="500">
                                {entry.date}
                            </Typography>

                            <IconButton
                                size="small"
                                onClick={() => onEditEntry(entry)}
                                sx={{ color: 'text.secondary' }}
                            >
                                <EditOutlinedIcon fontSize="small" />
                            </IconButton>
                        </Box>

                        <Box sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}>
                            <Typography variant="body2" color="text.secondary">
                                {entry.dayLabel || "Cuota del día"}
                            </Typography>

                            <Box sx={{
                                display: 'flex',
                                alignItems: 'center'
                            }}>
                                <Typography variant="h6" fontWeight="600" sx={{ mr: 1 }}>
                                    {entry.hours}
                                </Typography>

                                {entry.status === 'success' ? (
                                    <CheckCircleOutlineIcon color="success" fontSize="small" />
                                ) : (
                                    <CancelOutlinedIcon color="error" fontSize="small" />
                                )}
                            </Box>
                        </Box>
                    </ListItem>
                ))}
            </List>
        </Paper>
    );
};

export default WorkHoursHistory;